import { type FC } from 'react'
import { useFormState, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { Button } from '@/components/atoms/Button'
import { FormControl } from '@/components/atoms/Form/FormControl'
import { FormField } from '@/components/atoms/Form/FormField'
import { FormItem } from '@/components/atoms/Form/FormItem'
import { Input } from '@/components/atoms/Input'

import { type JudicialVolunteerSearchFormData } from './JudicialVolunteerSearchFormZod'

export const JudicialVolunteerSearchFormBody: FC = () => {
  const intl = useIntl()

  const { isSubmitting } = useFormState<JudicialVolunteerSearchFormData>()
  const volunteerCode = useWatch<JudicialVolunteerSearchFormData, 'volunteerCode'>({ name: 'volunteerCode' })

  return (
    <div className="flex items-center gap-4">
      <div className="flex-1">
        <FormField<JudicialVolunteerSearchFormData, 'volunteerCode'>
          name="volunteerCode"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  placeholder={intl.formatMessage({ id: 'judicial.results.volunteerCodePlaceholder' })}
                  className="h-8 w-full border border-gray-300 bg-white text-sm"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <Button
        type="submit"
        variant="default"
        disabled={volunteerCode.length === 0 || isSubmitting}
        className="h-8 bg-gray-700 px-6 py-1 text-sm text-white hover:bg-gray-600">
        {intl.formatMessage({ id: 'judicial.results.searchButton' })}
      </Button>
    </div>
  )
}
